import {exeRequest} from '../utils/APIUtils'

export default {
    getAll : async  () => exeRequest(`/operateurs`, "GET"),
    upsert : async  (client) => exeRequest(`/operateurs`, "PUT", client),
    get : async  (id) => exeRequest(`/operateurs/${id}`, "GET"),
    resetPassword : async  (id) => exeRequest(`/operateurs/${id}/reset-password`, "GET"),
    lockUnlock : async  (id, value) => exeRequest(`/operateurs/${id}/lock-unlock/${value}`, "GET")
}